import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'
import { reloadForChunkError } from './core/utils/lazyWithRetry'
import initI18n from './i18n'
import { ensureDateFnsLocale } from './i18n/dateFnsLocale'
import registerIntegrations from './integrations'
import reportWebVitals from './reportWebVitals'

window.global ||= window

// Vite fires this when a dynamic import's chunk fails to load (e.g. stale chunks after a deploy).
// Reloading pulls the fresh index.html and new chunk names. Covers on-demand imports outside the
// router; route chunks are also guarded by lazyWithRetry.
window.addEventListener('vite:preloadError', () => reloadForChunkError())

Promise.all([
	registerIntegrations(),
	initI18n(localStorage.getItem('userLanguage') || 'nl'),
	ensureDateFnsLocale(localStorage.getItem('userLanguage') || 'nl'),
]).then(() =>
	createRoot(document.getElementById('root') as Element).render(
		<StrictMode>
			<App />
		</StrictMode>,
	),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
